import { v4 } from 'uuid';

import { AccessoriesData } from '../accessories/types';
import { BlueprintContext } from '../blueprint-context/blueprint-context.class';
import { kitchenLayouts } from './data';
import { RecordData } from '../../helpers-classes';

import { DesignDetailsData, KitchenData, KitchenDataIn, PriceBookPinnedBy } from './types';

export const kitchenData = (context: BlueprintContext, dataIn: KitchenDataIn = null): KitchenData => {
	const rd = new RecordData<KitchenDataIn>(dataIn);

	const layout = dataIn?.layout && Object.values(kitchenLayouts).includes(dataIn.layout) ? dataIn.layout : kitchenLayouts.Custom;

	const record: KitchenData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		version: rd.useNewOrDefault<number | null>('version', null),
		baseVersion: rd.useNewOrDefault<number | null>('baseVersion', null),
		createdBy: rd.useNewOrDefault<string>('createdBy', context.userEmail),
		createDate: rd.useNewOrDefault<string>('createDate', Date.now().toString()),
		material: dataIn?.material ?? null,
		fuelchoice: rd.useNewOrDefault<string>('fuelchoice', 'ng'),
		skyKey: rd.useNewOrDefault<string>('skyKey', 'sky/overcast'),
		floorKey: rd.useNewOrDefault<string>('floorKey', 'floor/grid-tile'),
		designPackageImage: rd.useNewOrDefault<string>('designPackageImage', ''),
		design: dataIn?.design ?? null,
		promotionalSkus: dataIn?.promotionalSkus ?? null,
		artifacts: {},
		accessories: rd.useNewOrDefault<AccessoriesData>('accessories', null),
		tax: rd.useNewOrDefault<number>('tax', 0),
		description: rd.useNewOrDefault<string>('description', ''),
		kitchenLayout: rd.useNewOrDefault<string>('kitchenLayout', ''),
		layout,
		location: rd.useNewOrDefault<string>('location', 'Not Set'),
		quoteId: rd.useNewOrDefault<string>('quoteId', ''),
		isFinalized: rd.useNewOrDefault<boolean>('isFinalized', false),
		dealId: rd.useNewOrDefault<string>('dealId', ''),
		priceBookVersionId: rd.useNewOrDefault<string | null>('priceBookVersionId', null),
		priceBookPinnedBy: rd.useNewOrDefault<PriceBookPinnedBy | null>('priceBookPinnedBy', null),
		priceBookRuleId: rd.useNewOrDefault<string | null>('priceBookRuleId', null),
		notes: dataIn?.notes ?? null,
		skuAnnotations: dataIn?.skuAnnotations ?? null,
		blueprintAnnotations: dataIn?.blueprintAnnotations ?? null,
		designDetails: rd.useNewOrDefault<DesignDetailsData | null>('designDetails', null),
		blueprintOverrides: dataIn?.blueprintOverrides ?? {},
		blueprintOverrideBases: dataIn?.blueprintOverrideBases ?? {}
	};

	return record;
};
